import { db } from './db.js';

const apiBase = (import.meta.env.VITE_ODOO_API_URL || '').replace(/\/$/, '');
const apiToken = import.meta.env.VITE_ODOO_API_TOKEN || '';
const storeNames = ['zones', 'employes', 'equipes', 'categories', 'unites', 'variantes', 'produits', 'produits_variantes', 'stock_lignes'];

let activeSync = null;

export function isSyncConfigured() {
  return Boolean(apiBase && apiToken);
}

export async function pendingCount() {
  return db.mouvements.where('statut').equals('en_attente').count();
}

export async function syncNow() {
  if (activeSync) return activeSync;
  activeSync = performSync().finally(() => { activeSync = null; });
  return activeSync;
}

async function performSync() {
  if (!isSyncConfigured()) throw new Error('Synchronisation non configurée');
  const pending = await db.mouvements.where('statut').equals('en_attente').limit(100).toArray();
  const lastSync = await db.meta.get('last_sync_at');
  const response = await fetch(`${apiBase}/soontech_terrain/api/sync`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${apiToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      jsonrpc: '2.0',
      method: 'call',
      id: Date.now(),
      params: {
        mouvements: pending.map(({ local_id, statut, created_at, ...movement }) => movement),
        last_sync_at: lastSync?.value || null,
      },
    }),
  });
  if (!response.ok) throw new Error(`Serveur indisponible (${response.status})`);
  const envelope = await response.json();
  if (envelope.error) throw new Error(envelope.error.data?.message || envelope.error.message || 'Synchronisation refusée');
  const result = envelope.result;

  await db.transaction('rw', [...storeNames.map((name) => db[name]), db.mouvements, db.meta], async () => {
    for (const name of storeNames) {
      const rows = result.cache?.[name] || [];
      if (rows.length) await db[name].bulkPut(rows);
    }
    const accepted = new Map((result.accepted || []).map((item) => [item.uuid_client, item]));
    for (const movement of pending) {
      const server = accepted.get(movement.uuid_client);
      if (server) await db.mouvements.update(movement.local_id, { statut: 'synchronise', server_id: server.server_id });
    }
    await db.meta.put({ key: 'last_sync_at', value: result.synchronized_at });
  });
  return result;
}

export function startAutomaticSync(onChange) {
  const run = async () => {
    if (!navigator.onLine || !isSyncConfigured()) return;
    try { await syncNow(); onChange?.(null); } catch (error) { onChange?.(error); }
  };
  const interval = setInterval(run, 10 * 60 * 1000);
  window.addEventListener('online', run);
  run();
  return () => { clearInterval(interval); window.removeEventListener('online', run); };
}
